module.exports = __webpack_public_path__ + "img/working-on-the-go-stay-productive.5ccef1b5.png";